(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-tabs-maxdesign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('section-tabs-maxdesign'))
      customElements.define(
        'section-tabs-maxdesign',
        class SectionTabs extends HTMLElement {
          constructor() {
            super();
            this.section = this.parentElement;
            this.index = 1;
            this.tabs = this.querySelectorAll('.st-md__tab');
            this.tabs.forEach(tab => tab.addEventListener('click', e => (this.index = [...this.tabs].indexOf(e.target) + 1)));
          }
          set index(index) {
            this.section.dataset.tabActive = index;
          }
        }
      );
  })();

  } catch(e) { console.error(e); }
})();
})();
